<template>
  <a
    :class="b()"
    :href="entry.detailUrl"
    :title="entry.title"
  >
    <e-picture
      v-if="image"
      :class="b('image', { showPlaceholder })"
      :sizes="sizes"
      :srcset="image.srcset"
      :fallback="image.fallback"
      :alt="image.alt"
      :ratio="375 / 234"
      :loading="disableLazyLoading ? 'auto' : 'lazy'"
      height="234"
      width="375"
      @image-loaded="showPlaceholder = false"
    />
    <div
      v-else
      :class="b('image')"
    ></div>

    <div :class="b('content')">
      <div :class="b('top-content')">
        <span
          v-if="getMainCategory"
          :class="b('tag')"
        >
          {{ getMainCategory }}
        </span>
        <span :class="b('date')">
          {{ date }}
        </span>
        <div :class="b('title')">
          {{ entry.title }}
        </div>
        <div :class="b('teaser-text')">
          {{ entry.teaserText }}
        </div>
      </div>
      <span :class="b('link')">
        {{ $t('c-blog-list-item.readMoreLinkText') }}
        <e-icon-sprite icon="i-chevron-2--right" />
      </span>
    </div>
  </a>
</template>

<script>
  import eIconSprite from '@/elements/e-icon-sprite.vue';
  import ePicture from '@/elements/e-picture.vue';
  import { formatDate } from '@/helpers/format-date-time.js';

  /**
   * This component renders a blog entry preview item.
   */
  export default {
    name: 'c-blog-list-item',
    components: {
      eIconSprite,
      ePicture,
    },

    // mixins: [],

    props: {
      /**
       * Gets a blog entry object.
       */
      entry: {
        type: Object,
        required: true,
      },

      /**
       * Allows disabling of lazy loading for the current instance to improve LCP.
       */
      disableLazyLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        /**
         * @type {Object} Defines the sizes for the image per viewport.
         */
        sizes: {
          0: 287,
          sm: 321,
          md: 215,
          lg: 362,
        },
        showPlaceholder: true,
      };
    },

    computed: {
      /**
       * Gets the image object.
       *
       * @returns {Object|null}
       */
      image() {
        const { image } = this.entry || {};

        return image || null;
      },

      /**
       * Returns the main category.
       *
       * @returns {String}
       */
      getMainCategory() {
        return this.entry?.categories.length ? this.entry.categories[0] : '';
      },

      /**
       * Returns the main category.
       *
       * @returns {String}
       */
      date() {
        return formatDate(this.entry.date);
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-blog-list-item {
    $this: &;

    display: flex;
    flex-direction: column;
    border: 1px solid variables.$color-grayscale--900;
    color: variables.$color-grayscale--200;

    &:hover,
    &:focus {
      color: variables.$color-grayscale--200;

      #{$this}__link {
        color: variables.$color-primary--1;

        svg path {
          fill: variables.$color-primary--1;
        }
      }
    }

    &__content {
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      justify-content: space-between;
      padding: functions.rem(variables.$spacing--25 variables.$spacing--25 variables.$spacing--40);
    }

    &__tag {
      margin-right: functions.rem(variables.$spacing--30);
    }

    &__title {
      @extend %heading-h3;
      @include mixins.line-clamp(2, 1.2);

      margin: functions.rem(variables.$spacing--10) 0 0.3em;
    }

    &__link {
      margin-top: functions.rem(variables.$spacing--15);
      color: variables.$color-primary--2;

      .e-icon-sprite {
        display: inline-block;
        vertical-align: middle;
        width: 1rem;
        height: 1rem;
      }
    }

    &__image {
      &--show-placeholder {
        background: url('../assets/placeholder/placeholder--file.svg') no-repeat center center
          variables.$color-grayscale--920;
        background-size: 35%;
      }

      &:not(.e-picture) {
        padding-top: math.percentage(math.div(234, 375));
      }

      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
</style>
